// Module
var code = `<template>
  <require from="./grid-filter.scss"></require>

  <div class="grid-filter__row">
    <slot></slot>
    <div class="grid-filter__actions">
      <mdc-text-field placeholder="Search" value.bind="searchText & debounce:300" class="grid-filter__input">
        <button mdc-icon-button mdc-text-field-icon trailing tabindex="0" icon="filter_alt" title="Filters" click.trigger="openDialog() & stopPropagation"></button>
      </mdc-text-field>
      <button mdc-button outlined ref="exportAnchor" click.trigger="exportMenu.toggle()">
        <span class="mdc-button__label">Export</span><mdc-icon>arrow_drop_down</mdc-icon>
      </button>
      <mdc-menu view-model.ref="exportMenu" anchor.bind="exportAnchor" anchor-corner="BOTTOM_LEFT" hoist-to-body>
        <mdc-list>
          <mdc-list-item mdclistitem:action.trigger="exportCsv()">Csv</mdc-list-item>
          <mdc-list-item mdclistitem:action.trigger="exportExcel()">Excel</mdc-list-item>
        </mdc-list>
      </mdc-menu>
    </div>
  </div>
  <mdc-chip-set class="grid-filter__chips" if.bind="chips.length" mdcchipset:removal.trigger="chipRemoved(\$event.detail)">
    <mdc-chip repeat.for="chip of chips" mdcchip:interaction.trigger="chipClicked(\$event.detail)">
      <button mdc-chip-action>\${chip}</button>
      <button mdc-chip-action trailing icon="close"></button>
    </mdc-chip>
  </mdc-chip-set>
</template>
`;
// Exports
export default code;